import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import request from "../../../../network/request";
import { IRepairOrderDetail } from "../../types";
import moment from "moment";
import useQuery from "../../../../hooks/useQuery";

import styles from "./index.module.scss";

import useGetCh from "../../../../hooks/useGetCh";
import { reportUserBehavior } from "../../../../utils/common";
import LoadingHomepage from "../../../maintence/components/LoadingHomepage";
import { ErrorPlaceholder } from "../../../../components/placeholder";
import Progress from "./components/progress";
import MessageBox from "../../../../components/message-box";
import { pay } from "../../../../network/api/order";

export default function RepairOrderDetail() {
  document.title = "维修服务详情";
  const ch = useGetCh();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [preview, setPreview] = useState<Boolean>(false);
  const [repairOrderDetail, setRepairOrderDetail] =
    useState<IRepairOrderDetail | null>(null);
  const [progressList, setProgressList] = useState([]);
  const query = useQuery();
  // 获取路由query参数
  const repairOrderCode = query.get("repairOrderCode");
  const repairSettlementCode = query.get("repairSettlementCode");
  let history = useHistory();

  // 初始化请求
  useEffect(() => {
    getInitData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getInitData = async () => {
    setLoading(true);
    setError(false);
    await getRepairOrderDetail();
    setLoading(false);
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "repair_order_detail",
        ch,
        pa: `status=success`
      },
      "page"
    );
  };
  const reloadData = async () => {
    await getInitData();
  };

  const getRepairOrderDetail = async () => {
    try {
      let data: any = await request(
        "serviceOrder/getRepairOrderDetail",
        {
          repairOrderCode: repairOrderCode,
          balanceOrderCode: repairSettlementCode
        },
        "POST"
      );

      if (data.preGetDate) {
        data.preGetDate = moment(data.preGetDate).format("YYYY/MM/DD HH:mm:ss");
      }
      setRepairOrderDetail(data);

      // let progressListBak = JSON.parse(JSON.stringify(progressList));
      // if (data.repairTime) {
      //   progressListBak[0].status = 1;
      //   progressListBak[0].date = moment(data.repairTime).format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   );
      // }
      // if (data.repairDispatchTime) {
      //   progressListBak[1].status = 1;
      //   progressListBak[1].date = moment(data.repairDispatchTime).format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   );
      // }
      // if (data.repairStartTime) {
      //   progressListBak[2].status = 1;
      //   progressListBak[2].date = moment(data.repairStartTime).format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   );
      // }
      // if (data.repairFinishTime) {
      //   progressListBak[3].status = 1;
      //   progressListBak[3].date = moment(data.repairFinishTime).format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   );
      // }
      // if (data.balanceStartDate) {
      //   progressListBak[4].status = 1;
      //   progressListBak[4].date = moment(data.balanceStartDate).format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   );
      // }
      // if (data.balanceFinishDate) {
      //   progressListBak[5].status = 1;
      //   progressListBak[5].date = moment(data.balanceFinishDate).format(
      //     "YYYY/MM/DD HH:mm:ss"
      //   );
      // }

      setProgressList(data.repairStatusList || []);
      window.scrollTo(0, 0);
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "get_repair_order_detail_data_success",
          ch,
          pa: `status=success\`repairOrderCode=${repairOrderCode}`
        },
        "event"
      );
    } catch (err) {
      reportUserBehavior(
        {
          so: "J001002",
          mcode: "get_repair_order_detail_data_error",
          ch,
          pa: `status=error\`repairOrderCode=${repairOrderCode}\`errMessage=${
            (err as any)?.msg
          }`
        },
        "page"
      );
      setError(true);
      
      setErrorMsg((err as any).message || "加载数据失败，请稍后重试");
    }
  };

  const progress = <Progress progressList={progressList}></Progress>;

  // 维修项目
  const wiDetailList =
    repairOrderDetail?.wiDetailList &&
    repairOrderDetail?.wiDetailList.length > 0 ? (
      <div className={styles.vehicle}>
        <p className={styles.title}>维修项目</p>
        {repairOrderDetail?.wiDetailList.map((item, index) => {
          return (
            <div className={styles.message} key={index}>
              <span className={styles.messageLeft}>
                {item.wiName}
                {item.businessTypeName ? (
                  <span className={styles.tag}>{item.businessTypeName}</span>
                ) : null}
              </span>
              <span className={styles.messageRight}>
                {item.saleWorkQty}工时｜¥ {item.wiPreAmount}
                {item.wiAmount && item.wiPreAmount !== item.wiAmount && (
                  <span className={styles.originAmount}>
                    ¥ {item.wiAmount || 0}
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    ) : null;

  // 配件详情
  const partDetailList =
    repairOrderDetail?.partDetailList &&
    repairOrderDetail?.partDetailList.length > 0 ? (
      <div className={styles.vehicle}>
        <p className={styles.title}>配件详情</p>
        {repairOrderDetail?.partDetailList.map((item, index) => {
          return (
            <div className={styles.message} key={index}>
              <span className={styles.messageLeft}>
                {item.partName} x {item.partQty}
                {item.businessTypeName ? (
                  <span className={styles.tag}>{item.businessTypeName}</span>
                ) : null}
              </span>
              <span className={styles.messageRight}>
                ¥ {item.prePartAmount}
                {item.partAmount && item.prePartAmount !== item.partAmount && (
                  <span className={styles.originAmount}>
                    ¥ {item.partAmount || 0}
                  </span>
                )}
              </span>
            </div>
          );
        })}
      </div>
    ) : null;

  // 其他费用
  const otherDetailList =
    repairOrderDetail?.otherDetailList &&
    repairOrderDetail?.otherDetailList.length ? (
      <div className={styles.vehicle}>
        <p className={styles.title}>其他费用</p>
        {repairOrderDetail?.otherDetailList.map((item, index) => {
          return (
            <div className={styles.message} key={index}>
              <span className={styles.messageLeft}>
                {item.otherCostName}
                {item.businessTypeName ? (
                  <span className={styles.tag}>{item.businessTypeName}</span>
                ) : null}
              </span>
              <span className={styles.messageRight}>¥ {item.otherAmount}</span>
            </div>
          );
        })}
      </div>
    ) : null;

  // 费用减免
  const couponInfoList =
    (repairOrderDetail?.couponInfoList &&
      repairOrderDetail?.couponInfoList.length > 0) ||
    Number(repairOrderDetail?.totalDiscountAmount) > 0 ? (
      <div className={styles.vehicle}>
        <p className={styles.title}>费用减免</p>
        {repairOrderDetail?.couponInfoList &&
          repairOrderDetail?.couponInfoList.length > 0 &&
          repairOrderDetail?.couponInfoList.map((item, index) => {
            return (
              <div key={index}>
                <div className={styles.messageNoPdb}>
                  <span className={styles.messageLeft}>{item.couponName}</span>
                  <span className={styles.messageRight}>
                    - ¥ {item.cancelAmount}
                  </span>
                </div>
                <div className={styles.smallMsg}>券号:{item.couponCode}</div>
              </div>
            );
          })}
        {Number(repairOrderDetail?.totalDiscountAmount) > 0 && (
          <div className={styles.message}>
            <span className={styles.messageLeft}>折扣减免</span>
            <span className={styles.messageRight}>
              - ¥ {repairOrderDetail?.totalDiscountAmount}
            </span>
          </div>
        )}
      </div>
    ) : null;

  // 合计费用
  const totalAmount = (
    <div className={styles.vehicle}>
      <p className={styles.title}>合计费用</p>
      <div className={styles.message}>
        <span className={styles.messageLeft}>总维保费用</span>
        <span className={styles.messageRight}>
          ¥ {repairOrderDetail?.totalAmount}
        </span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>总减免费用</span>
        <span className={styles.messageRight}>
          - ¥ {repairOrderDetail?.totalCancelAmount}
        </span>
      </div>
      <div className={styles.message}>
        <span className={styles.messageLeft}>总结算费用</span>
        <span className={styles.messageRight}>
          ¥ {repairOrderDetail?.totalDueAmount}
        </span>
      </div>
    </div>
  );

  // 签名提示
  const signTips = (
    <div className={styles.signTips}>
      <div>
        ①维修安全操作需要，车辆维修期间将进入检查模式，APP无法控制车辆；车辆交付前，我们会为您退出检查模式，感谢您的支持！
      </div>
      <div>
        ②本人同意以上所有项目及费用，如遇价格变化或在维修过程中需要追加项目/更改配件的，以实际项目结算单为正式结算依据。
      </div>
    </div>
  );

  // 客户签名
  const signatureImage = repairOrderDetail?.signPic ? (
    <div className={styles.vehicle}>
      <p className={styles.title}>客户签名</p>
      <div
        className={styles.signaImage}
        onClick={() => {
          setPreview(true);
        }}
      >
        <img
          src={
            repairOrderDetail?.signPic &&
            repairOrderDetail?.signPic.split("|").length > 1
              ? repairOrderDetail?.signPic.split("|")[1]
              : repairOrderDetail?.signPic
          }
          alt=""
        />
      </div>
    </div>
  ) : null;

  // 预览图片
  const previewImage = preview ? (
    <div>
      <div className={styles.mask}></div>
      <div
        className={styles.imagePreview}
        onClick={() => {
          setPreview(false);
        }}
      >
        <div className={styles.imagePreviewSwipe}>
          <div className={styles.swipeItem}>
            <div className={styles.itemImage}>
              <img
                className={styles.imgs}
                src={
                  repairOrderDetail?.signPic &&
                  repairOrderDetail?.signPic.split("|").length > 1
                    ? repairOrderDetail?.signPic.split("|")[1]
                    : repairOrderDetail?.signPic
                }
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;

  const handleAutograph = () => {
    history.push(
      `/serviceOrders/signatureAgreement?repairOrderCode=${repairOrderCode}`
    );
  };

  // toSign
  const toSign = (
    <div
      className={styles.autograph}
      onClick={() => {
        handleAutograph();
        reportUserBehavior(
          {
            so: "J001002",
            mcode: "repair_order_detail_to_sign",
            ch,
            pa: `repairOrderCode=${repairOrderCode}`
          },
          "event"
        );
      }}
    >
      <span className={styles.signText}>请确认并签署施工单</span>
      <button className={styles.autographBtn}>去签名</button>
    </div>
  );

  // signed
  const signed = (
    <div className={styles.signed}>
      <span className={styles.signText}>请确认并签署施工单</span>

      <button className={styles.signedBtn}>已签名</button>
    </div>
  );

  // 签名
  const autograph =
    repairOrderDetail?.signStatus === 0
      ? null
      : repairOrderDetail?.signStatus === 1
      ? toSign
      : !repairOrderDetail?.balanceStartDate
      ? signed
      : repairOrderDetail.gatheringState === "31101"
      ? signed
      : repairOrderDetail.canApplyInvoice === 1
      ? signed
      : signed;

  // 底部按钮
  const btnWrapper = !(
    repairOrderDetail?.appPayStatus === 0 ||
    repairOrderDetail?.canApplyInvoice === 1
  ) && <div>{autograph}</div>;

  const toBilling = useCallback(
    (billUrl) => {
      reportUserBehavior({
        so: "J001002",
        mcode: "settlement_detail_click_toBilling",
        ch,
        pa: `event=已支付，去开票`
      });
      setTimeout(() => {
        window.location.href = billUrl;
      }, 300);
    },
    [ch]
  );

  const getOrderPay = useCallback(
    async (params) => {
      try {
        const res: any = await pay(params);
        reportUserBehavior({
          so: "J001002",
          mcode: "get_order_pay_success",
          ch,
          pa: `status=success\`balanceCode=${params.balanceCode}\`token=${params.token}\`payment=${params.payment}\`payFromType=${params.payFromType}`
        });
        // MessageBox
        if (res.url) {
          setTimeout(() => {
            window.location.href = res.url;
          }, 300);
        } else if (res.code === 4003) {
          MessageBox.confirm("交易请求已提交，请勿重复支付", {
            showCancelButton: false,
            confirmButtonText: "我知道了"
          }).then(() => {
            window.location.reload();
          });
        } else if (res.code === 4007) {
          MessageBox.confirm("结算内容发生变更，请与服务管家联系", {
            showCancelButton: false,
            confirmButtonText: "确定"
          }).then(() => {
            setTimeout(() => {
              history.push(`/serviceOrders/mainOrderList`);
            }, 300);
          });
        }
      } catch (error) {
        setLoading(false);
        setError(true);
        setErrorMsg((error as any).message || "加载数据失败，请稍后重试");
        reportUserBehavior({
          so: "J001002",
          mcode: "get_order_pay_error",
          ch,
          pa: `status=error\`balanceCode=${params.balanceCode}\`token=${params.token}\`payment=${params.payment}\`payFromType=${params.payFromType}`
        });
      }
    },
    [ch, history]
  );

  const handlePay = useCallback(async () => {
    reportUserBehavior({
      so: "J001002",
      mcode: "settlement_detail_click_toPay",
      ch,
      pa: `event=去支付`
    });
    if (repairOrderDetail?.balanceOrderCode) {
      await getOrderPay({
        balanceCode: repairOrderDetail?.balanceOrderCode,
        token: repairOrderDetail?.token,
        payment: "cashier",
        payFromType: 1
      });
    }
  }, [ch, getOrderPay, repairOrderDetail]);

  const pageContainerClass = `${styles.detailPageWrapper}`;

  // 支付方式
  const payWayInfo = () => {
    if (repairOrderDetail?.balanceOrderCode) {
      return (
        <div className={styles.vehicle}>
          <p className={styles.title}>支付方式</p>
          <div className={styles.message}>
            <span className={styles.messageLeft}>
              <span>其他支付方式</span>
              {repairOrderDetail?.notAppPayStatus === 1 ? (
                <span className={styles.tag}>已支付</span>
              ) : null}
            </span>
            <span className={styles.messageRight}>
              ¥ {repairOrderDetail?.notAppBalanceAmount}
            </span>
          </div>
          <div className={styles.message}>
            <span className={styles.messageLeft}>
              APP内支付
              {repairOrderDetail?.appPayStatus === 1 ? (
                <span className={styles.tag}>已支付</span>
              ) : null}
            </span>
            <span className={styles.messageRight}>
              ¥ {repairOrderDetail?.appBalanceAmount}
            </span>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  const footer = useMemo(() => {
    if (repairOrderDetail) {
      if (repairOrderDetail?.appPayStatus === 0) {
        return (
          <div className={styles.payWrapper}>
            <div className={styles.payLeft}>
              <div className={styles.tip}>APP待支付</div>
              <div className={styles.amount}>
                ¥ {repairOrderDetail?.appBalanceAmount}
              </div>
            </div>
            <div
              className={styles.payRight}
              onClick={() => {
                handlePay();
              }}
            >
              <div className={styles.payBtn}>去支付</div>
            </div>
          </div>
        );
      }
      if (repairOrderDetail?.canApplyInvoice === 1) {
        return (
          <div
            className={styles.paidWrapper}
            onClick={() => {
              toBilling(repairOrderDetail?.invoiceUrl);
            }}
          >
            <div className={styles.paid}>
              <span>已支付，去开票</span>
            </div>
          </div>
        );
      }
    }
  }, [handlePay, repairOrderDetail, toBilling]);

  if (loading) {
    return <LoadingHomepage></LoadingHomepage>;
  }

  if (error) {
    reportUserBehavior(
      {
        so: "J001002",
        mcode: "repair_order_detail",
        ch,
        pa: `status=error`
      },
      "page"
    );
    return (
      <ErrorPlaceholder
        message={errorMsg}
        getData={reloadData}
      ></ErrorPlaceholder>
    );
  }

  return (
    <div className={pageContainerClass}>
      {progress}
      {wiDetailList}
      {partDetailList}
      {otherDetailList}
      {couponInfoList}
      {totalAmount}
      {payWayInfo()}
      {signTips}
      {/* {signatureImage} */}
      {/* {previewImage} */}
      {footer}
      {btnWrapper}
    </div>
  );
}
